import { render } from "./DepositOrders.vue?vue&type=template&id=844401b6"
import script from "./deposit-orders-component.ts?vue&type=script&lang=js&external"
export * from "./deposit-orders-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__